import clsx from 'clsx';
import React from 'react';
export const FormTextarea = React.forwardRef(function FormTextarea(props, ref) {
    const { className, ...rest } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("textarea", { className: clsx(className, 'py-2 px-3 border border-app-gray-line focus:border-y-app-gray-light rounded-md text-sm focus:outline-none focus:ring-2'), ref: ref, ...rest })));
});
